import { render, staticRenderFns } from "./EsgLcaGhgMgmtByProduct.vue?vue&type=template&id=5e999098&scoped=true"
import script from "./EsgLcaGhgMgmtByProduct.vue?vue&type=script&lang=js"
export * from "./EsgLcaGhgMgmtByProduct.vue?vue&type=script&lang=js"
import style0 from "./EsgLcaGhgMgmtByProduct.vue?vue&type=style&index=0&id=5e999098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e999098",
  null
  
)

export default component.exports